import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const FreshmanIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.04826 2H17.0483C17.6272 2 18.0965 2.46932 18.0965 3.04826V6.82449C18.0965 7.40068 17.6315 7.86886 17.0553 7.87273L12.4013 7.90326V9.23026L15.9552 9.23081C16.4955 9.23081 16.9404 9.63964 16.9973 10.1648L17.0034 10.2791V14.1232C17.0034 14.7022 16.5341 15.1715 15.9552 15.1715L12.4013 15.1713L12.4021 21.0483C12.4021 21.5886 11.9932 22.0334 11.468 22.0904L11.3538 22.0965H7.04826C6.46932 22.0965 6 21.6272 6 21.0483V3.04826C6 2.46932 6.46932 2 7.04826 2ZM15.9993 5.78326V4.09626H8.09626V19.9993H10.3053L10.3056 14.1232C10.3056 13.5829 10.7144 13.1381 11.2396 13.0811L11.3538 13.075L14.9063 13.0743V11.3273L11.3538 11.3273C10.8135 11.3273 10.3686 10.9185 10.3117 10.3933L10.3056 10.2791V6.86271C10.3056 6.28652 10.7706 5.81835 11.3468 5.81448L15.9993 5.78326Z"
            />
        </svg>
    );
};
